export default {
    has_okr: 'OKR',
    has_talk: 'Talk',
    has_value: 'Avaliações',
    has_kpi: 'KPI',
    has_goal: 'Target',
    has_pdi: 'PDI',
    has_mini_curriculum: 'Mini Curriculo',
    has_career_objective: 'Objetivos de Carreira',
}
